import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/logoBw.png';
import { useLanguage } from '../LanguageContext';
import './Navbar.css';

const LINK_KEYS = [
  { href: '#home', key: 'home' },
  { href: '#about', key: 'about' },
  { href: '#projects', key: 'projects' },
  { href: '#contact', key: 'contact' },
];

function Navbar({ visible }) {
  const { lang, toggleLang, t } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  const LangToggle = (
    <button
      type="button"
      className="navbar-lang-toggle"
      onClick={toggleLang}
      aria-label={lang === 'en' ? 'Passer au français' : 'Switch to English'}
      title={lang === 'en' ? 'Passer au français' : 'Switch to English'}
    >
      <span className="navbar-lang-flag" aria-hidden="true">🇨🇦</span>
      <span className="navbar-lang-code">{lang === 'en' ? 'FR' : 'EN'}</span>
    </button>
  );

  return (
    <div className="navbar-position">
      <AnimatePresence>
        {visible && (
          <motion.nav
            className="navbar glass"
            initial={{ opacity: 0, marginTop: -20 }}
            animate={{ opacity: 1, marginTop: 0 }}
            exit={{ opacity: 0, marginTop: -20 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <a href="#home" className="navbar-brand" onClick={() => setMenuOpen(false)}>
              <img src={logo} alt="Santhosh Dayakar" className="navbar-logo" />
            </a>

            <div className="navbar-links">
              {LINK_KEYS.map((link) => (
                <a key={link.href} href={link.href}>
                  {t.nav[link.key]}
                </a>
              ))}
            </div>

            <div className="navbar-desktop-lang">{LangToggle}</div>

            <button
              type="button"
              className="navbar-burger"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
            >
              {menuOpen ? <FiX /> : <FiMenu />}
            </button>

            <AnimatePresence>
              {menuOpen && (
                <motion.div
                  className="navbar-mobile-panel glass"
                  initial={{ opacity: 0, marginTop: -12 }}
                  animate={{ opacity: 1, marginTop: 0 }}
                  exit={{ opacity: 0, marginTop: -12 }}
                  transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                >
                  {LINK_KEYS.map((link) => (
                    <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>
                      {t.nav[link.key]}
                    </a>
                  ))}
                  {LangToggle}
                </motion.div>
              )}
            </AnimatePresence>
          </motion.nav>
        )}
      </AnimatePresence>
    </div>
  );
}
export default Navbar;
